import './modules/customer-card/loader';
import './modules/customer-card-shipping/loader';

import { attachEventListeners } from './modules/cart/event-handlers.js';
import { setLanguage } from './utils/language-utils.js';
import { validateKortSelectFields } from './utils/customer-card-utility';

setLanguage();
attachEventListeners();
validateKortSelectFields();
